import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Link, useNavigate } from 'react-router-dom';


function SubCategoryList() {

  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [loading, setLoading] = useState(true);
  const [subCategories, setSubCategories] = useState([""]);
  const navigate = useNavigate();
  const userToken = localStorage.getItem('loginToken');

  let axiosConfig = {
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        "Access-Control-Allow-Origin": "*",
        "Authorization": `Bearer ${userToken}`
    }
  };

const getAllSubCategory = ()=>{

  axios.get(baseUrl+"/api/v1/admin/sub-category/list", axiosConfig).then((res) =>{
    console.log("Response for fetchdata",res.data);
    console.log("Response for fetchdata",res.data.status);
    if(res.data.status === 'OK'){
      setSubCategories(res.data.data);
        console.log("CATEGORIES IS ==", subCategories);
    }else{
       // setFailedResponse(res.data.msg) 
    }
   }).catch(err =>{
     console.log('Exception ==='+err);
   });
}



    const deleteSubCategory = (item)=>{
     console.log(item);
     //confirm();
     axios.put(baseUrl+"/api/v1/admin/category/delete", axiosConfig).then((res) =>{
      console.log("Response for fetchdata",res.data);
      console.log("Response for fetchdata",res.data.status);
      if(res.data.status === 'OK'){
          setSubCategories(res.data.data);
          console.log("CATEGORIES IS ==", subCategories);
      }else{
         // setFailedResponse(res.data.msg) 
      }
     }).catch(err =>{
       console.log('Exception ==='+err);
     });
    }

    const updateSubCategory = (item) =>{
        console.log(item,"jjj");
        //  <EditBrand data={item} />

        const encodedModelId = btoa(item.modelId);
         let updatePath = `/dashboard/edit-model/${encodedModelId}`;
         navigate(updatePath);
        console.log(item);
       }

       useEffect  (()=>{
        getAllSubCategory();
       },[])
         
  return (
    <div className="col-lg-12 col-md-12 mx-auto" style={{marginTop:"7%", backgroundColor:"#fff"}}>
      <table className="table table-striped">
        <thead>
            <tr>
                <th>Sr No</th>
                <th>Name</th>
                <th>Label</th>
                <th>Created At</th>
                <th>Category</th>
                 <th>Action</th>
                
            </tr>
        </thead>
        <tbody>
            {subCategories.length > 0 ? subCategories.map((item, index)=>{
                return(
                    <tr key={index}>
                <td>{index+1}</td>
                <td>{item.subCategoryName}</td>
                <td>{item.subCategoryLabel}</td>
                <td>{item.createdAt}</td> 
                <td>{item.category?.categoryName}</td>
                <td>
                    <ul className='d-flex action-list'>
                        <li><button className='btn btn-primary' onClick={() => updateSubCategory(item)}><i style={{fontSize:"1rem"}} className="bx bx-edit"></i></button></li>
                        <li><button className='btn btn-danger' onClick={() => deleteSubCategory(item)}><i style={{ fontSize:"1rem"}} className="bx bx-trash"></i></button></li>
                    </ul>
                </td>
                
            </tr>
                )
            }):<tr>
           <td colSpan={6}>No data Available</td>
            </tr>
}  
            
           
           
        </tbody>
       
    </table>
    </div>
  )
}

export default SubCategoryList
